import React, { useState, useRef, useEffect } from 'react';

export function useTimer(initialTime: boolean, milliseconds: number) {
  const Ref = useRef<NodeJS.Timeout | null>(null);

  //Timeout indicator
  const [timeout, setTimeout] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const startTimer = (e: Date) => {
    const nDate = new Date();
    const total = e.getTime() - nDate.getTime();
    if (total <= 0 || timeout == true) {
      if (Ref.current !== null) {
        clearInterval(Ref.current);
      }
      setTimeout(true);
      setConfirm(false);
    }
  };

  const resetTimer = () => {
    setTimeout(false);
    const newDate = new Date();
    newDate.setTime(newDate.getTime() + milliseconds);
    clearTimer(newDate);
  };

  function clearTimer(e: Date) {
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  }

  useEffect(() => {
    const newDate = new Date();
    newDate.setTime(newDate.getTime() + milliseconds);
    if (initialTime) {
      clearTimer(newDate);
    }
  }, [initialTime]);

  useEffect(() => {
    if (!timeout && confirm) {
      const newDate = new Date();
      newDate.setTime(newDate.getTime() + milliseconds);
      clearTimer(newDate);
    }
  }, [timeout, confirm]);

  function init(start: boolean) {
    setConfirm(start);
    setTimeout(false);
  }

  return { timeout, resetTimer, init };
}

export default useTimer;
